import CrudAPI from '@/api/resources/crud'

export default {
  data () {
    return {
      dialogResult: false,
      itemLoaded: false,
      itemData: {},
      resource: ''
    }
  },
  computed: {
    itemId () {
      return this.$store.getters.editItemId
    }
  },
  watch: {
    itemId (newVal) {
      this.changedItemIdAction(newVal)
    }
  },
  methods: {
    changedItemIdAction (itemId) {
      if (itemId > 0) {
        this.loadItemData(itemId).then(() => {
          this.itemLoaded = true
        }, () => {})

        this.dialogResult = true
      }
    },
    loadItemData (itemId) {
      let result = CrudAPI.dfsResourceShow(this.resource, itemId)

      return new Promise((resolve, reject) => {
        result.then(result => {
          this.itemData = result

          if (this.itemData.password) {
            this.itemData.password = ''
          }

          resolve(this.itemData)
        }, error => {
          reject(error)
        })
      })
    },
    editItemData (customItemId = 0) {
      let id = customItemId > 0 ? customItemId : this.itemId

      let result = CrudAPI.dfsResourceUpdate(this.resource, id, this.itemData)

      result.then(result => {
        this.$bus.$emit('resource-updated')

        this.dialogResult = false

        this.afterEditCallback()
      }, () => {})
    },
    dialogClose () {
      this.dialogResult = false

      this.itemLoaded = false

      this.$bus.$emit('dialog-closed')
    },
    setEditItemIdZero () {
      this.$store.dispatch('setEditItemId', 0)
    },
    afterEditCallback () {

    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/EditResourceDialog.js